import { render } from "./OrgsTable.vue?vue&type=template&id=3324c549"
import script from "./OrgsTable.vue?vue&type=script&lang=js"
export * from "./OrgsTable.vue?vue&type=script&lang=js"

import "./OrgsTable.vue?vue&type=style&index=0&id=3324c549&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__